export default {"src":"/_next/static/media/WBA.9618697e.svg","height":18,"width":18};